import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import { useQuery, useQueryClient } from '@tanstack/react-query';
import API_URL from './api/config';

function SignupNoTotem() {
    const navigate = useNavigate();
   
   
    const [totemName, setTotemName] = useState('');
  const [imageFile, setImageFile] = useState(null); // optional image

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file); // Store it optionally
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        document.getElementById("blah").src = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  };

  const handleTotemSubmit = async () => {
    if (!totemName.trim()) {
      toast.error("Please enter your totem name.");
      return;
    }

    const formData = new FormData();
    formData.append("clan_name", totemName);
    if (imageFile) {
      formData.append("image", imageFile); // Only if selected
    }

    try {
      const res = await axios.post(`${API_URL}/reg-signup-nototem-api`, formData, {
        withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data.Status === "Success") {
        navigate(res.data.redirect);
      } else {
        toast.error(res.data.Message || "Failed to register clan.");
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error("Something went wrong.");
    }
  };


    return (
        <div className="bg-med-green min-vh-100 d-flex align-items-center justify-content-center">
            <div className="container">
            <ToastContainer />
            <div className="rowx justify-content-center">
                
            <div className=" clan_border">
                    
        
                        <div className='row' style={{ marginBottom: "20%" }}>
                        <p class="h5 text-center" >You can register your new totem here.</p>
                        </div>

                        <div className="row" >
        <div className="col-md-2"></div>

        <div className="col-md-8">
          <center>
            <div className="profile-pic-wrapper " style={{ marginTop: "20%" }} >
              <label
                htmlFor="avatar_upload"
                className="avatar avatar-xxl profile-cover-avatar-square"
                style={{
                  height: "162px",
                  width: "162px",
                  position: "relative",
                  cursor: "pointer",
                  display: "inline-block",
                }}
              >
                <img
                  id="blah"
                  src="#"
                  alt="Upload Preview"
                  className="avatar-img"
                  style={{
                    height: "100%",
                    width: "100%",
                    objectFit: "cover",
                    borderRadius: "10px",
                    backgroundColor: "#fff",
                  }}
                />
                <input
                  type="file"
                  name="image"
                  id="avatar_upload"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={handleImageChange}
                />
                <span
                  className="avatar-edit"
                  style={{
                    position: "absolute",
                    bottom: "5px",
                    right: "5px",
                    backgroundColor: "#184A2C",
                    color: "#fff",
                    borderRadius: "50%",
                    padding: "8px",
                  }}
                >
                  <i className="fas fa-edit avatar-uploader-icon shadow-soft"></i>
                </span>
              </label>
              
              
              
            </div>

            <label>Upload Totem (optional)</label>
          </center>

          <label htmlFor="totem_name" className="form-label">
            Enter Your Totem
          </label>
          <input
            type="text"
            name="totem_name"
            id="totem_name"
            className="form-control"
            required
            value={totemName}
            onChange={(e) => setTotemName(e.target.value)}
          />
        </div>

        <div className="col-md-2"></div>
      </div>

      <div className="row" style={{ marginTop: "20%" }}>
        <div className="col-4 col-md-4">
          <Link onClick={() => navigate(-1)} className="btn btn-primary">
            &emsp;<i className="fa fa-arrow-left btn_arrow"></i>&emsp;
          </Link>
        </div>
        <div className="col-4 col-md-4"></div>
        <div className="col-4 col-md-4">
          <button
            onClick={handleTotemSubmit}
            className="btn btn-primary"
            type="submit"
          >
            &emsp;<i className="fa fa-arrow-right btn_arrow"></i>&emsp;
          </button>
        </div>
      </div>
                 
                    

                </div>
            </div>
        </div>
        </div>
    );
}

export default SignupNoTotem;
